import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { translate } from 'react-polyglot';
import { FormRadio } from './form';
import { Button } from './buttons';
import { Edit } from './icons';
import profileIcons from './icons/profileIcons';
import './ProfileOption.css';

class ProfileOption extends Component {
  constructor(props) {
    super(props);

    this.handleEdit = this.handleEdit.bind(this);
    this.handleSelect = this.handleSelect.bind(this);
  }

  handleEdit() {
    this.props.onEdit(this.props.id);
  }

  handleSelect(e) {
    const profileId = e.currentTarget.value.replace(/^profile_/, '');
    this.props.onSelect(profileId);
  }

  render() {
    const { isEditing, icon, id, title, t } = this.props;
    return (
      <div
        className={classNames('profile-option', {
          'profile-option--editing': isEditing
        })}
      >
        <FormRadio
          name="profile"
          value={`profile_${id}`}
          imageSrc={profileIcons[icon]}
          onClick={this.handleSelect}
          disabled={isEditing}
        >
          {title}
        </FormRadio>
        {isEditing && (
          <Button
            className="profile-option__edit-button"
            colorScheme="blue"
            type="button"
            onClick={this.handleEdit}
            ariaLabel={t('profile.editButton')}
          >
            <Edit
              className="profile-option__edit-button-icon"
              viewBox="0 0 32 32"
              width="1.6rem"
              height="1.6rem"
            />
          </Button>
        )}
      </div>
    );
  }
}

ProfileOption.defaultProps = {
  icon: 'tulip',
  id: '',
  isEditing: false,
  onEdit() {},
  onSelect() {},
  title: ''
};

ProfileOption.propTypes = {
  icon: PropTypes.string,
  id: PropTypes.string,
  isEditing: PropTypes.bool,
  onEdit: PropTypes.func,
  onSelect: PropTypes.func,
  title: PropTypes.string,
  t: PropTypes.func.isRequired
};

export default translate()(ProfileOption);



// WEBPACK FOOTER //
// ./src/components/ProfileOption.js